"use client";

import type { ReactNode } from "react";
import { useUser } from "../hooks/useUser";

type AuthGateProps = {
  /** Shown when user IS authenticated */
  children: ReactNode;
  /** Shown when user is NOT authenticated */
  fallback: ReactNode;
};

export function AuthGate({ children, fallback }: AuthGateProps) {
  const { plan, loading } = useUser();

  if (loading) return <>{fallback}</>;

  return <>{plan !== "anonymous" ? children : fallback}</>;
}
